import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Image } from "react-bootstrap";
import commuteLoader from "../../assets/images/commute_loader.gif";

const PrivateRoute = ({ element }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return (
      <>
        <div className="loader">
          <Image src={commuteLoader} alt="loader" />
        </div>
      </>
    );
  }
  return isAuthenticated ? element : <Navigate to="/login" />;
};

export default PrivateRoute;